export default "__VITE_ASSET__$JYl54YI__"